import { render, staticRenderFns } from "./MANUAL.vue?vue&type=template&id=dba248b8&scoped=true"
import script from "./MANUAL.vue?vue&type=script&lang=js"
export * from "./MANUAL.vue?vue&type=script&lang=js"
import style0 from "./MANUAL.vue?vue&type=style&index=0&id=dba248b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba248b8",
  null
  
)

export default component.exports